/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { AssetContentType } from './AssetContentType';
import {
    AssetContentTypeFromJSON,
    AssetContentTypeFromJSONTyped,
    AssetContentTypeToJSON,
} from './AssetContentType';

/**
 * Render-ready asset metadata for task-facing UIs.
 * @export
 * @interface TaskViewAsset
 */
export interface TaskViewAsset {
    /**
     * CivicTech-generated identifier for a managed asset.
     * @type {string}
     * @memberof TaskViewAsset
     */
    assetId: string;
    /**
     * Original client-side file name.
     * @type {string}
     * @memberof TaskViewAsset
     */
    fileName: string;
    /**
     * 
     * @type {AssetContentType}
     * @memberof TaskViewAsset
     */
    contentType: AssetContentType;
    /**
     * URL that clients can use to read asset bytes directly from S3.
     * @type {string}
     * @memberof TaskViewAsset
     */
    url: string;
}


/**
 * Check if a given object implements the TaskViewAsset interface.
 */
export function instanceOfTaskViewAsset(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "assetId" in value;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "contentType" in value;
    isInstance = isInstance && "url" in value;
    return isInstance;
}

export function TaskViewAssetFromJSON(json: any): TaskViewAsset {
    return TaskViewAssetFromJSONTyped(json, false);
}

export function TaskViewAssetFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskViewAsset {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'assetId': json['assetId'],
        'fileName': json['fileName'],
        'contentType': AssetContentTypeFromJSON(json['contentType']),
        'url': json['url'],
    };
}

export function TaskViewAssetToJSON(value?: TaskViewAsset | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'assetId': value.assetId,
        'fileName': value.fileName,
        'contentType': AssetContentTypeToJSON(value.contentType),
        'url': value.url,
    };
}

